import { MssHyroxMainPart, PreviewSlideData, WorkoutWuCd } from '@/types/workouts'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import RoundPreviewComponent from '../round-preview/round-preview.component.vue'
import HyroxZonePreviewComponent from '../hyrox-zone-preview/hyrox-zone-preview.component.vue'

@Component({
    components: {
        'round-preview-component': RoundPreviewComponent,
        'hyrox-zone-preview-component': HyroxZonePreviewComponent
    }
})
export default class TrainingPreviewComponent extends Vue {
    @Prop({ type: Array, default: []}) workoutData!: PreviewSlideData[]
    @Prop({type: Boolean, default: false}) isHyrox?: boolean
    @Prop({}) mainParts?: MssHyroxMainPart[]

    get warmingUpSlides() {
        return this.workoutData.filter(workout => workout.activity_type == WorkoutWuCd.WU)
    }

    get coolingDownSlides() {
        return this.workoutData.filter(workout => workout.activity_type == WorkoutWuCd.CD)
    }

    get actualWorkoutSlides() {
        return this.workoutData.filter(workout => workout.activity_type == undefined)
    }

    get hasWarmingUps() {
        return this.warmingUpSlides.length > 0
    }
    
    get hasCoolingDowns() {
        return this.coolingDownSlides.length > 0
    }

    @Emit()
    onPreviewUpdate(d: {workoutPartIdx: number; roundIdx?: number}) {
        return d
    }

    @Emit()
    onPreviewSlideUpdate(slideIdx: number) {
        return slideIdx
    }

    onRoundUpdate(d: number|{roundIdx: number, workoutPartIdx: number}) {
        if (this.isHyrox && typeof d == 'object') {
            this.onPreviewUpdate({ workoutPartIdx: this.warmingUpSlides.length + d.workoutPartIdx, roundIdx: d.roundIdx })
        } else if (Number.isInteger(d)){
            this.onPreviewUpdate({ workoutPartIdx: this.warmingUpSlides.length, roundIdx: d as number })
        }
    }

    onWarmingUpTouch(workoutPartIdx: number) {
        this.onPreviewUpdate({ workoutPartIdx })
    }

    onCoolingDownTouch(coolingDownIdx: number) {
        let mainPartLength = 1
        if (this.mainParts) {
            mainPartLength = this.mainParts.length
        }
        this.onPreviewUpdate({ workoutPartIdx: (this.warmingUpSlides.length + coolingDownIdx + mainPartLength) })
    }
}